import React from 'react';
import { electricBlue } from 'components/common/colorConstants';

const SimplrLogo = ({ color = electricBlue }) => (
  <svg width="100%" height="100%" viewBox="0 0 83 31">
    <title>simplrLogo</title>
    <defs>
      <polygon id="path-1" points="0 0 83 0 83 31 0 31" />
    </defs>
    <g
      id="TopNav/nav"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
      transform="translate(-77.000000, -35.000000)"
    >
      <g id="Page-1" transform="translate(77.000000, 35.000000)">
        <mask id="mask-2" fill="white">
          <use xlinkHref="#path-1" />
        </mask>
        <g id="Clip-2" />
        <path
          d="M26.3334576,21 L30.5475835,21 L30.5475835,9.87465877 L26.3334576,9.87465877 L26.3334576,21 Z M31,5.27704898 C31,6.53496572 29.8809013,7.55409795 28.5,7.55409795 C27.1189822,7.55409795 26,6.53496572 26,5.27704898 C26,4.01934449 27.1189822,3 28.5,3 C29.8809013,3 31,4.01934449 31,5.27704898 Z"
          id="Fill-1"
          fill={color}
          mask="url(#mask-2)"
        />
        <path
          d="M33,9.34109993 L36.843333,9.34109993 L36.843333,10.5681477 L36.8868998,10.5681477 C37.7553662,9.6590669 38.8628122,9 40.0788564,9 C41.5553449,9 43.183892,9.56831452 43.9657562,11.1364622 C45.1382336,9.6590669 46.4410926,9 47.6571368,9 C49.6981869,9 52,10.0682311 52,13.3180782 L52,21 L48.1565607,21 L48.1565607,14.4092198 C48.1565607,13.2500139 47.570322,12.2272702 46.2023254,12.2272702 C44.986175,12.2272702 44.4650739,13.1590391 44.4216134,14.045543 L44.4216134,21 L40.5782804,21 L40.5782804,14.4092198 C40.5782804,13.2500139 39.9919354,12.2272702 38.6239388,12.2272702 C37.342757,12.2272702 36.843333,13.2500139 36.843333,14.1816716 L36.843333,21 L33,21 L33,9.34109993 Z"
          id="Fill-3"
          fill={color}
          mask="url(#mask-2)"
        />
        <path
          d="M59.326591,12.257626 C57.8315947,12.257626 56.7483056,13.3362521 56.7483056,14.8465608 C56.7483056,16.3783007 57.89659,17.4569267 59.326591,17.4569267 C60.7783279,17.4569267 61.9265062,16.3783007 61.9265062,14.8465608 C61.9265062,13.3362521 60.8865826,12.257626 59.326591,12.257626 M60.4749814,20.7143416 C58.9798791,20.7143416 57.7448638,20.2183658 56.8349306,19.3336749 L56.8349306,26 L53,26 L53,9.32368284 L56.7915651,9.32368284 L56.7915651,10.5749186 L56.8349306,10.5749186 C57.6582388,9.66879673 58.9582494,9 60.4749814,9 C63.7248489,9 66,11.6103659 66,14.8465608 C66,18.0825447 63.7248489,20.7143416 60.4749814,20.7143416"
          id="Fill-4"
          fill={color}
          mask="url(#mask-2)"
        />
        <polygon id="Fill-5" fill={color} mask="url(#mask-2)" points="67 21 71 21 71 2 67 2" />
        <path
          d="M73,9.34109993 L76.9507805,9.34109993 L76.9507805,11.0229105 L76.995456,11.0229105 C76.995456,11.0229105 78.2453877,9 80.4999181,9 C81.9731182,9 83,9.72746483 83,9.72746483 L81.3480977,13.136351 C81.3480977,13.136351 80.6115523,12.4999722 79.2946619,12.4999722 C77.2410075,12.4999722 76.9507805,14.5682589 76.9507805,14.863649 L76.9507805,21 L73,21 L73,9.34109993 Z"
          id="Fill-6"
          fill={color}
          mask="url(#mask-2)"
        />
        <path
          d="M18.4010559,21.5449849 C14.236612,21.5449849 11.7120762,19.1495324 11.7120762,19.1495324 L13.7404476,15.6773414 C13.7404476,15.6773414 16.113885,17.7211225 18.0989648,17.7211225 C18.9836979,17.7211225 20.6666866,17.6331509 20.6666866,15.9411487 C20.6666866,14.622327 18.7678733,14.0290024 16.653341,12.9521564 C14.5171629,11.875418 13.2656123,10.1830933 13.2656123,8.29310118 C13.2656123,4.90877427 16.2001515,2.75508236 19.0698588,2.75508236 C20.247708,2.75508236 21.2973717,2.98296976 22.1592976,3.27172752 C21.0017216,1.31559538 18.8955308,0 16.5017147,0 L6.60070699,0 C2.97043957,0 0,3.02523486 0,6.72294728 L0,16.8072069 C0,20.5048118 2.97043957,23.5300466 6.60070699,23.5300466 L12.0348628,23.5300466 L22.9191186,31 L23,20.2868185 C21.762704,21.176429 20.1110754,21.5449849 18.4010559,21.5449849"
          id="Fill-7"
          fill={color}
          mask="url(#mask-2)"
        />
        <path
          d="M17,7.47859504 C17,8.39766882 18.4420258,9.05712554 20.1799841,9.85641367 C20.7947382,10.13813 21.4302103,10.5231064 21.9924004,11 L22,7.20030118 L21.8993052,7.13889269 C21.8993052,7.13889269 20.3833641,6 18.8118735,6 C17.6285962,6 17,6.57937144 17,7.47859504"
          id="Fill-8"
          fill={color}
          mask="url(#mask-2)"
        />
      </g>
    </g>
  </svg>
);

export default SimplrLogo;
